var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75406 6.47406L10.9262 2.32894C11.5793 1.89035 12.4207 1.89035 13.0738 2.32894L19.2459 6.47406C19.4736 6.62694 19.6682 6.82677 19.8177 7.06105L21.8353 10.2226C22.2679 10.9005 21.7978 11.8039 21.0125 11.8039H19.5911V19.9608C19.5911 21.087 18.7083 22 17.6194 22H14.0122L12 19.6524L9.98781 22H6.38064C5.2917 22 4.40894 21.087 4.40894 19.9608V11.8039H2.9875C2.20217 11.8039 1.7321 10.9005 2.1647 10.2226L4.18226 7.06105C4.33177 6.82677 4.52643 6.62694 4.75406 6.47406ZM14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9ZM12 17.3476L14.0121 15.0001L14 15H10L9.98787 15.0001L12 17.3476ZM12.9878 18.5L15 20.8476V16.1524L12.9878 18.5ZM11.0122 18.5L9 16.1524V20.8476L11.0122 18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarn);
export default __webpack_public_path__ + "static/media/barn.34344385225513a9f56d6913f9aecb5f.svg";
export { ForwardRef as ReactComponent };